import React, { useState } from "react";
import { Loader2, KeyRound, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StarDashLayout } from "@/pages/star/StarLayout";

export default function ForceChangePassword() {
  const { refresh } = useAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Use at least 6 characters"); return; }
    if (pw !== confirm) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/student/change-password", { new_password: pw });
      toast.success("Password updated — welcome back!");
      await refresh();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not update password");
    } finally { setBusy(false); }
  };

  return (
    <StarDashLayout title="Student Portal" testid="force-change-password">
      <div className="max-w-md mx-auto mt-8 rounded-3xl bg-white border border-slate-200 shadow-sm p-6 sm:p-8">
        <div className="flex items-center gap-2 mb-1"><KeyRound className="h-5 w-5 text-blue-900" />
          <h2 className="text-xl font-bold text-slate-900">Set a new password</h2></div>
        <p className="text-sm text-slate-500 mb-5">You logged in with a temporary password issued by PTG. Please choose your own password to continue.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="force-change-form">
          <div><Label className="mb-1 block font-semibold text-slate-700">New password</Label>
            <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="At least 6 characters" data-testid="force-pw" /></div>
          <div><Label className="mb-1 block font-semibold text-slate-700">Confirm password</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="force-pw-confirm" /></div>
          <Button type="submit" disabled={busy} className="w-full h-11 bg-blue-900 hover:bg-blue-950" data-testid="force-submit">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password & continue"}
          </Button>
          <p className="text-[11px] text-slate-400 flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5" /> Your fees, stars and records are safe and unchanged.</p>
        </form>
      </div>
    </StarDashLayout>
  );
}
